import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { NotinoLabelRegular400, truncate } from '../../../../styles/helpers'

export const Badge = styled.span<{ $isActive: boolean }>`
	${({ $isActive }) => css`
		${truncate};
		max-width: 100%;
		min-width: 0;
		background-color: ${$isActive ? theme.color.common.green95 : theme.color.common.red95};
		color: ${$isActive ? theme.color.text.positive : theme.color.text.negative};
		border-radius: 2px;
		display: inline-block;
		${NotinoLabelRegular400};
		padding: 4px 10px;
	`}
`
